import { observable, computed } from 'mobx';
import type { Moment } from 'moment';
import moment from 'moment';

export type OpenMeetingBlockedSlotResponseArgs = {
  id: number;
  open_meeting_id: number;
  start_at: string;
  end_at: string;
};

export type OpenMeetingBlockedSlotArgs = {
  id?: number;
  openMeetingId?: number;
  startAt: Moment;
  endAt: Moment;
};

export const blockedSlotTitle = '除外日時（ダブルクリックで削除）';
export const blockedSlotMobileTitle = '除外日時（ロングタップで削除）';
export const blockedSlotDisabledTitle = '除外日時（除外日時モードで編集）';

export const convertOpenMeetingBlockedSlotResponseToArgs = (response: OpenMeetingBlockedSlotResponseArgs) => {
  const args: OpenMeetingBlockedSlotArgs = {
    id: response.id,
    openMeetingId: response.open_meeting_id,
    startAt: moment(response.start_at),
    endAt: moment(response.end_at)
  };
  return args;
};

export default class OpenMeetingBlockedSlot {
  @observable id?: number;
  @observable openMeetingId?: number;
  @observable startAt: Moment;
  @observable endAt: Moment;

  constructor(args: OpenMeetingBlockedSlotArgs) {
    this.id = args.id;
    this.openMeetingId = args.openMeetingId;
    this.startAt = args.startAt;
    this.endAt = args.endAt;
  }

  setTime(type: 'start' | 'end', time: string) {
    const [hour, minute] = time.split(':').map(str => parseInt(str, 10));
    if (type === 'start') {
      this.startAt.set('hour', hour).set('minute', minute);
      if (this.startAt.unix() > this.endAt.unix()) {
        this.endAt = this.startAt.clone().add('hour', 1);
      }
    } else {
      this.endAt.set('hour', hour).set('minute', minute);
      if (this.startAt.unix() > this.endAt.unix()) {
        this.startAt = this.endAt.clone().subtract('hour', 1);
      }
    }
  }

  @computed
  get timeText() {
    let text = this.startAt.year() !== moment().year() ? this.startAt.format('YYYY年') : '';
    text += this.startAt.format('MM月DD日(ddd) HH:mm - ') + this.endAt.format('HH:mm');
    return text;
  }

  submitParams() {
    return {
      id: this.id,
      open_meeting_id: this.openMeetingId,
      start_at: this.startAt.format(),
      end_at: this.endAt.format()
    };
  }
}
